module.exports = __webpack_public_path__ + "media/theme/icon__login-c10b76f5.svg";